import Stack from '../../DataDisplay/Stack/Stack.js';
import '../../../styles/forms.css.js';
import 'bootstrap/dist/css/bootstrap.css';
import '../../Forms/Autocomplete/Autocomplete.js';
import '../../../styles/fonts.css.js';
import 'classnames';
import React__default, { useState } from 'react';
import Tooltip from '../../Layout/Tooltip/Tooltip.js';
import '../../Forms/Button/Button.module.scss.js';
import '../../../styles/general.css.js';
import '../../Forms/ButtonClose/ButtonClose.module.css.js';
import ButtonIcon from '../../Forms/ButtonIcon/ButtonIcon.js';
import '../../Forms/Checkbox/Checkbox.js';
import '@mui/x-date-pickers';
import '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs';
import '../../Forms/FloatingButton/FloatingButton.module.css.js';
import '../../Forms/Input/Input.js';
import '../../DataDisplay/Table/Table.module.scss.js';
import 'react-intersection-observer';
import '../../../node_modules/lodash/_baseClone.js';
import '../../DataDisplay/TextTruncate/TextTruncate.module.css.js';
import '../../Forms/Radio/Radio.js';
import Select from '../../Forms/Select/Select.js';
import SelectOption from '../../Forms/SelectOption/SelectOption.js';
import '../../Forms/Slider/Slider.module.scss.js';
import '../../Forms/Textarea/Textarea.js';
import '../../Layout/Footer/Footer.module.scss.js';
import '../../Layout/Header/Header.module.scss.js';
import '@azure/msal-react';
import 'copy-to-clipboard';
import '../../Hooks/useDateTimeFormat/useDateTimeFormat.js';
import 'use-debounce';
import '../../Hooks/useFromNow/useFromNow.js';
import 'crypto-js';
import '../../../node_modules/@faker-js/faker/dist/esm/chunk-3LPAMF3R.js';
import '../../../node_modules/@faker-js/faker/dist/esm/chunk-LSZKOVGW.js';
import '../../../node_modules/@faker-js/faker/dist/esm/chunk-GTEBSQTL.js';
import 'react-router-dom';
import '../../Providers/LanguageProvider/LanguageProvider.js';
import '../../Layout/MenuOption/MenuOption.module.scss.js';
import '../../Layout/Tabs/Tabs.js';

/* type TSentiment = 'NEUTRAL' | 'POSITIVE' | 'NEGATIVE'; */
const Reasons = [
    {
        value: 'Incomplete',
        label: 'Incomplete response',
        action: 'Needs more information',
    },
    { value: 'Outdated', label: 'Outdated response', action: 'Needs updating' },
    {
        value: 'Incorrect',
        label: 'Factually incorrect information',
        action: 'Needs correcting',
    },
    {
        value: 'NotRelevant',
        label: 'Information provided is not relevant',
        action: 'Model needs more training',
    },
];
/* type TFeedbackForm = {
  query_id: string;
  sentiment: TSentiment;
  reason?: TFeedbackReason['value'];
  comment?: string;
}; */
const Feedback = () => {
    const [selectedValue, setSelectedValue] = useState();
    return selectedValue ? ('Thanks for your feedback') : (React__default.createElement(Select, { id: "FeedbackReason", placeholder: "Select a reason", size: "small", onChange: event => setSelectedValue(event.target.options[event.target.selectedIndex].value) }, Reasons.map((item, index) => {
        return (React__default.createElement(SelectOption, { key: index, label: `${item.label} (${item.action})`, value: item.value }));
    })));
};
const sendFeedbackMessage = () => {
    alert('sent');
};
const ChatFeedback = ({ message = React__default.createElement(Feedback, null), placement = 'right', showTooltip = true, showReasons = false, }) => {
    const [feedbackSent, setFeedbackSent] = useState(false);
    const handleThumbsUp = () => {
        sendFeedbackMessage();
    };
    const handleThumbsDown = () => {
        showReasons ? showFeedbackMessage() : sendFeedbackMessage();
    };
    const showFeedbackMessage = () => {
        setFeedbackSent(true);
    };
    const ThumbsUpButton = () => {
        return (React__default.createElement("div", { style: { display: 'inline-block' } },
            React__default.createElement(ButtonIcon, { onClick: handleThumbsUp, icon: 'IconThumbUp', size: "small", hoverType: "color" })));
    };
    const ThumbsDownButton = () => {
        return (React__default.createElement("div", { style: { display: 'inline-block' } },
            React__default.createElement(ButtonIcon, { onClick: handleThumbsDown, icon: 'IconThumbDown', size: "small", hoverType: "color" })));
    };
    return (React__default.createElement("div", { style: {
            color: '#CCCCCC',
            fontSize: 13,
            textAlign: placement,
            marginTop: 10,
            height: 20,
        } }, feedbackSent ? (message) : (React__default.createElement(React__default.Fragment, null, showTooltip ? (React__default.createElement(Stack, { direction: "row", horizontalAlign: placement },
        React__default.createElement(Tooltip, { title: "Good response" },
            React__default.createElement("span", null,
                React__default.createElement(ThumbsUpButton, null))),
        React__default.createElement(Tooltip, { title: "Bad response" },
            React__default.createElement("span", null,
                React__default.createElement(ThumbsDownButton, null))))) : (React__default.createElement(Stack, { direction: "row", horizontalAlign: placement },
        React__default.createElement(ThumbsUpButton, null),
        React__default.createElement(ThumbsDownButton, null)))))));
};

export { ChatFeedback as default };
//# sourceMappingURL=ChatFeedback.js.map
